import { render, staticRenderFns } from "./UserPayrollAdjustmentItems.vue?vue&type=template&id=067a6fe0&scoped=true&"
import script from "./UserPayrollAdjustmentItems.vue?vue&type=script&lang=ts&"
export * from "./UserPayrollAdjustmentItems.vue?vue&type=script&lang=ts&"
import style0 from "./UserPayrollAdjustmentItems.vue?vue&type=style&index=0&id=067a6fe0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067a6fe0",
  null
  
)

export default component.exports